class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if (window.OwlsCartCRO && typeof window.OwlsCartCRO.refresh === 'function') window.OwlsCartCRO.refresh();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  if (window.OwlsCartCROBooted) return;
  window.OwlsCartCROBooted = true;

  const FREE_SHIPPING_CENTS = 7500;
  const BUY_TWO_QTY = 2;
  const BUY_TWO_PERCENT = 10;
  let timer;
  let renderToken = 0;

  const root = () => (window.Shopify?.routes?.root || '/');
  const clamp = (value) => Math.max(0, Math.min(100, value));
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[char]));

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  };

  function ensureStyles() {
    if (document.getElementById('owls-cart-cro-v2-styles')) return;
    const style = document.createElement('style');
    style.id = 'owls-cart-cro-v2-styles';
    style.textContent = `
      .owls-cart-rewards-v2{margin:0 -1.5rem .8rem;padding:1.15rem 1.5rem 1.2rem;background:#0d0d0d;color:#fff;border-top:1px solid rgba(255,255,255,.07);border-bottom:1px solid rgba(255,255,255,.07)}
      .owls-cart-rewards-v2__row{display:flex;align-items:center;justify-content:space-between;gap:1rem}.owls-cart-rewards-v2__label{font-size:1.12rem;font-weight:700;letter-spacing:.02em;color:#fff}.owls-cart-rewards-v2__message{font-size:1.08rem;line-height:1.3;text-align:right;color:rgba(255,255,255,.76)}.owls-cart-rewards-v2__message strong{color:#8ECFAE;font-weight:700}.owls-cart-rewards-v2__bar{height:.55rem;margin:.75rem 0 .9rem;overflow:hidden;border-radius:999px;background:rgba(255,255,255,.14)}.owls-cart-rewards-v2__bar span{display:block;height:100%;border-radius:inherit;background:#8ECFAE;transition:width .25s ease}.owls-cart-rewards-v2__buy2{display:flex;align-items:center;gap:.7rem;padding-top:.8rem;border-top:1px solid rgba(255,255,255,.1);font-size:1.08rem;line-height:1.35;color:rgba(255,255,255,.8)}.owls-cart-rewards-v2__dot{width:.75rem;height:.75rem;flex:0 0 .75rem;border:1px solid #8ECFAE;border-radius:50%;background:transparent}.owls-cart-rewards-v2__buy2.is-unlocked .owls-cart-rewards-v2__dot{background:#8ECFAE}.owls-cart-rewards-v2__buy2 strong{color:#fff}.owls-cart-rewards-v2__fineprint{margin:.65rem 0 0;font-size:.92rem;line-height:1.35;color:rgba(255,255,255,.5)}
      .owls-cart-pairings{margin:1rem .1rem .6rem;padding:1.05rem;border:1px solid rgba(var(--color-foreground),.11);border-radius:1.5rem;background:rgba(var(--color-foreground),.025)}.owls-cart-pairings__intro{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-bottom:.85rem}.owls-cart-pairings__eyebrow{display:block;color:rgba(var(--color-foreground),.58);font-size:.9rem;font-weight:700;letter-spacing:.11em;text-transform:uppercase}.owls-cart-pairings__intro strong{font-size:1.3rem;color:rgb(var(--color-foreground))}.owls-cart-pairings__group+.owls-cart-pairings__group{margin-top:.9rem;padding-top:.9rem;border-top:1px solid rgba(var(--color-foreground),.1)}.owls-cart-pairings__group-title{display:block;margin-bottom:.55rem;font-size:1rem;font-weight:700;color:rgba(var(--color-foreground),.62)}.owls-cart-pairing{display:grid;grid-template-columns:5.8rem minmax(0,1fr) auto;gap:.8rem;align-items:center}.owls-cart-pairing__image{display:block;width:5.8rem;height:5.8rem;overflow:hidden;border-radius:1rem;background:rgba(var(--color-foreground),.04)}.owls-cart-pairing__image img{display:block;width:100%;height:100%;object-fit:contain}.owls-cart-pairing__info{min-width:0}.owls-cart-pairing__title{display:-webkit-box;overflow:hidden;color:rgb(var(--color-foreground));text-decoration:none;font-size:1.08rem;line-height:1.28;font-weight:600;-webkit-box-orient:vertical;-webkit-line-clamp:2}.owls-cart-pairing__price{display:block;margin-top:.25rem;font-size:1rem;color:rgba(var(--color-foreground),.62)}.owls-cart-pairing__button{min-width:6.8rem;padding:.65rem .75rem;border:1px solid #101010;border-radius:999px;background:#8ECFAE;color:#101010;text-align:center;text-decoration:none;font:inherit;font-size:.98rem;line-height:1.2;font-weight:700;cursor:pointer}.owls-cart-pairing__button:hover{filter:brightness(.97)}.owls-cart-pairing__button:disabled{opacity:.55;cursor:wait}.owls-cart-pairings__loading{padding:.4rem 0;font-size:1rem;color:rgba(var(--color-foreground),.55)}
      @media screen and (min-width:750px){.drawer__inner{width:44rem}}
      @media screen and (max-width:420px){.owls-cart-rewards-v2__row{align-items:flex-start;flex-direction:column;gap:.25rem}.owls-cart-rewards-v2__message{text-align:left}.owls-cart-pairing{grid-template-columns:5.2rem minmax(0,1fr) auto}.owls-cart-pairing__image{width:5.2rem;height:5.2rem}.owls-cart-pairing__button{min-width:6.2rem;padding-inline:.6rem}}
    `;
    document.head.appendChild(style);
  }

  async function cartData() {
    const response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function rewardHost() {
    const inner = document.querySelector('#CartDrawer .drawer__inner');
    const header = inner?.querySelector('.drawer__header');
    if (!inner || !header) return null;
    let element = inner.querySelector('.owls-cart-rewards-v2');
    if (!element) {
      element = document.createElement('section');
      element.className = 'owls-cart-rewards-v2';
      element.setAttribute('aria-label', 'Cart rewards');
      element.setAttribute('aria-live', 'polite');
      header.insertAdjacentElement('afterend', element);
    }
    return element;
  }

  function renderRewards(cart) {
    const host = rewardHost();
    if (!host) return;
    const itemCount = Number(cart.item_count || 0);
    if (!itemCount) {
      host.remove();
      return;
    }

    const cartTotal = Number(cart.total_price || 0);
    const remainingShipping = Math.max(0, FREE_SHIPPING_CENTS - cartTotal);
    const shippingProgress = clamp((cartTotal / FREE_SHIPPING_CENTS) * 100);
    const shippingMessage = remainingShipping === 0
      ? '<strong>Free U.S. shipping unlocked</strong>'
      : `<strong>${money(remainingShipping)}</strong> away`;
    const buyTwoUnlocked = itemCount >= BUY_TWO_QTY;
    const remainingItems = Math.max(0, BUY_TWO_QTY - itemCount);
    const buyTwoMessage = buyTwoUnlocked
      ? `<strong>${BUY_TWO_PERCENT}% off unlocked automatically.</strong>`
      : `<strong>Add ${remainingItems} more item${remainingItems === 1 ? '' : 's'}</strong> to unlock ${BUY_TWO_PERCENT}% off.`;

    host.innerHTML = `
      <div class="owls-cart-rewards-v2__row">
        <span class="owls-cart-rewards-v2__label">Free shipping at ${money(FREE_SHIPPING_CENTS)}</span>
        <span class="owls-cart-rewards-v2__message">${shippingMessage}</span>
      </div>
      <div class="owls-cart-rewards-v2__bar" role="progressbar" aria-label="Progress toward free U.S. shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(shippingProgress)}"><span style="width:${shippingProgress}%"></span></div>
      <div class="owls-cart-rewards-v2__buy2${buyTwoUnlocked ? ' is-unlocked' : ''}"><span class="owls-cart-rewards-v2__dot" aria-hidden="true"></span><span>${buyTwoMessage}</span></div>
      <p class="owls-cart-rewards-v2__fineprint">Offers combine when eligible. Shipping is for eligible U.S. destinations; checkout confirms availability.</p>
    `;
  }

  function pairingHost() {
    const contents = document.querySelector('#CartDrawer-CartItems');
    if (!contents) return null;
    let host = contents.querySelector('.owls-cart-pairings');
    if (!host) {
      host = document.createElement('section');
      host.className = 'owls-cart-pairings';
      host.setAttribute('aria-label', 'Product pairings');
      const wrapper = contents.querySelector('.drawer__cart-items-wrapper');
      if (wrapper) wrapper.insertAdjacentElement('afterend', host);
      else contents.appendChild(host);
    }
    return host;
  }

  function productKind(value) {
    const haystack = `${value?.product_type || value?.type || ''} ${value?.product_title || value?.title || ''}`.toLowerCase();
    if (haystack.includes('vape')) return 'vape';
    if (haystack.includes('gumm')) return 'gummy';
    return '';
  }

  function productBrand(value) {
    const haystack = `${value?.product_title || value?.title || ''} ${(value?.tags || []).toString()}`.toLowerCase();
    if (haystack.includes('platinum')) return 'platinum';
    if (haystack.includes('golden')) return 'golden';
    return '';
  }

  function productImage(product) {
    const featured = product?.featured_image;
    if (typeof featured === 'string') return featured;
    if (featured?.url) return featured.url;
    if (featured?.src) return featured.src;
    const first = product?.images?.[0];
    if (typeof first === 'string') return first;
    return first?.src || first?.url || '';
  }

  function productUrl(product) {
    if (product?.url && String(product.url).startsWith('/')) return product.url;
    return root() + 'products/' + encodeURIComponent(product?.handle || '');
  }

  function availableVariant(product) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return variants.find((variant) => variant.available !== false) || null;
  }

  function usableProduct(product, inCart, seen) {
  if (!product || !product.id) return false;

  const id = String(product.id);

  // Keywords that should NEVER appear in recommendations
  const excludedKeywords = [
    '10 count',
    'wholesale',
    '10 cout',
    'case',
    'WS'
  ];

  // Check product title and URL handle
  const productText = `${product.title || ''} ${product.handle || ''}`.toLowerCase();

  // Exclude products containing any restricted keyword
  if (excludedKeywords.some(keyword => productText.includes(keyword))) {
    return false;
  }

  // Existing checks
  if (inCart.has(id) || seen.has(id) || product.available === false) {
    return false;
  }
  return Boolean(availableVariant(product));
}

  async function recommendations(productId, intent) {
    try {
      const response = await fetch(`${root()}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=${intent}`, {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (!response.ok) return [];
      return (await response.json()).products || [];
    } catch (error) {
      return [];
    }
  }

  async function collectionProducts(handle) {
    try {
      const response = await fetch(`${root()}collections/${encodeURIComponent(handle)}/products.json?limit=16`, {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (!response.ok) return [];
      return (await response.json()).products || [];
    } catch (error) {
      return [];
    }
  }

  function choose(products, inCart, seen, preferredKind = '', preferredBrand = '') {
    const usable = products.filter((product) => usableProduct(product, inCart, seen));
    return usable.find((product) => (!preferredKind || productKind(product) === preferredKind) && (!preferredBrand || productBrand(product) === preferredBrand))
      || usable.find((product) => !preferredKind || productKind(product) === preferredKind)
      || usable.find((product) => !preferredBrand || productBrand(product) === preferredBrand)
      || usable[0]
      || null;
  }

  async function complementaryPick(cart, inCart, seen) {
    const anchors = (cart.items || []).slice(0, 3);
    for (const anchor of anchors) {
      const currentKind = productKind(anchor);
      const oppositeKind = currentKind === 'vape' ? 'gummy' : currentKind === 'gummy' ? 'vape' : '';
      const brand = productBrand(anchor);
      const candidates = await recommendations(anchor.product_id, 'complementary');
      const pick = choose(candidates, inCart, seen, oppositeKind, brand);
      if (pick) return pick;
    }

    const anchor = anchors[0];
    if (!anchor) return null;
    const kind = productKind(anchor);
    const fallbackCollection = kind === 'vape' ? 'thca-gummies' : kind === 'gummy' ? 'thca-vapes' : '';
    if (!fallbackCollection) return null;
    const fallback = await collectionProducts(fallbackCollection);
    return choose(fallback, inCart, seen, kind === 'vape' ? 'gummy' : 'vape', productBrand(anchor));
  }

  async function pairedPick(cart, inCart, seen) {
    const anchors = (cart.items || []).slice(0, 3);
    for (const anchor of anchors) {
      const candidates = await recommendations(anchor.product_id, 'related');
      const pick = choose(candidates, inCart, seen, productKind(anchor), productBrand(anchor));
      if (pick) return pick;
    }

    const anchor = anchors[0];
    if (!anchor) return null;
    const kind = productKind(anchor);
    const fallbackCollection = kind === 'vape' ? 'thca-vapes' : kind === 'gummy' ? 'thca-gummies' : '';
    if (!fallbackCollection) return null;
    return choose(await collectionProducts(fallbackCollection), inCart, seen, kind, productBrand(anchor));
  }

  function card(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const variant = availableVariant(product);
    const url = productUrl(product);
    const image = productImage(product);
    const price = Number(variant?.price ?? product.price ?? 0);
    const action = variants.length === 1 && variant
      ? `<button class="owls-cart-pairing__button" type="button" data-owls-pairing-add="${escapeHtml(variant.id)}">Quick Add</button>`
      : `<a class="owls-cart-pairing__button" href="${escapeHtml(url)}">View</a>`;

    return `<article class="owls-cart-pairing">
      <a class="owls-cart-pairing__image" href="${escapeHtml(url)}" tabindex="-1" aria-hidden="true">${image ? `<img src="${escapeHtml(image)}" alt="" width="64" height="64" loading="lazy">` : ''}</a>
      <div class="owls-cart-pairing__info"><a class="owls-cart-pairing__title" href="${escapeHtml(url)}">${escapeHtml(product.title)}</a><span class="owls-cart-pairing__price">${money(price)}</span></div>
      ${action}
    </article>`;
  }

  function renderPairings(complementary, paired) {
    const host = pairingHost();
    if (!host) return;
    if (!complementary && !paired) {
      host.remove();
      return;
    }

    host.innerHTML = `
      <div class="owls-cart-pairings__intro"><div><span class="owls-cart-pairings__eyebrow">KEEP IT SIMPLE</span><strong>Upgrade your cart</strong></div></div>
      ${complementary ? `<div class="owls-cart-pairings__group"><span class="owls-cart-pairings__group-title">Complementary pick</span>${card(complementary)}</div>` : ''}
      ${paired ? `<div class="owls-cart-pairings__group"><span class="owls-cart-pairings__group-title">Frequently paired with</span>${card(paired)}</div>` : ''}
    `;
    host.querySelectorAll('[data-owls-pairing-add]').forEach((button) => button.addEventListener('click', quickAdd));
  }

  async function renderUpsells(cart, token) {
    const host = pairingHost();
    if (!host || !(cart.items || []).length) {
      if (host) host.remove();
      return;
    }

    host.innerHTML = '<div class="owls-cart-pairings__loading">Finding a useful pairing…</div>';
    const inCart = new Set((cart.items || []).map((item) => String(item.product_id)));
    const seen = new Set();
    const complementary = await complementaryPick(cart, inCart, seen);
    if (token !== renderToken) return;
    if (complementary) seen.add(String(complementary.id));
    const paired = await pairedPick(cart, inCart, seen);
    if (token !== renderToken) return;
    renderPairings(complementary, paired);
  }

  async function quickAdd(event) {
    const button = event.currentTarget;
    const variantId = Number(button.dataset.owlsPairingAdd);
    if (!variantId || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error('Unable to add product');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') drawer.renderContents(data);
      schedule(220);
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try again';
      setTimeout(() => { button.textContent = 'Quick Add'; }, 1400);
    }
  }

  async function refresh() {

  if (!document.querySelector('cart-drawer')) return;

  ensureStyles();

  const token = ++renderToken;

  try {

    const cart = await cartData();

    if (token !== renderToken) return;

    // renderRewards(cart);

    await renderUpsells(cart, token);

  } catch (error) {

    // Keep the native cart fully usable if recommendations are unavailable.

  }

}

  function schedule(delay = 160) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay);
  }

  function connectCartUpdates() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule());
      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', () => {
    ensureStyles();
    schedule(80);
    if (!connectCartUpdates()) {
      let tries = 0;
      const interval = setInterval(() => {
        tries += 1;
        if (connectCartUpdates() || tries >= 12) clearInterval(interval);
      }, 250);
    }
    document.addEventListener('click', (event) => {
      if (event.target.closest('#cart-icon-bubble')) schedule(60);
    });
  });

  window.addEventListener('pageshow', () => schedule(80));
  window.OwlsCartCRO = { refresh: () => schedule(40) };
})();
